module.exports = __webpack_public_path__ + "img/buttonexcelente.6ba3f5fb.png";